<template>
  <div :class="windowWidth < 576 ? 'col-2' : 'col-sm-6'" class="p-1" :id="`selected-image-${imageRef}`">
    <div class="card-sqr-gray ios-height-clear position-relative">
      <img :src="url" class="w-100 ar-3-2" :data-style-number="styleNumber">
      <h6 class="position-absolute m-0 image-overlay-text" v-if="isShowStyleNumber">{{styleNumber}}</h6>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SelectedStyleImage',
  props: {
    url: { type: String, default: '' },
    imageRef: { type: String, default: '' },
    styleNumber: { type: String, default: '' },
    isShowStyleNumber: { type: Boolean, default: false }
  },
  data () {
    return {
      windowWidth: 0
    }
  },
  methods: {
    calculateWindowWidth () {
      this.windowWidth = window.innerWidth
    }
  },
  mounted () {
    window.addEventListener('resize', this.calculateWindowWidth)
    this.calculateWindowWidth()
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.calculateWindowWidth)
  }
}
</script>
